import { useQueryClient } from 'react-query';
import { getFieldsOptions, FieldName } from '../api';

export const useFieldOptions = () => {
    const queryClient = useQueryClient();

    const getRegionsAndTimelineOptions = async <T>(fields: FieldName[], id: string): Promise<T> => {
        const requestType = `DM_FIELD_OPTIONS_${id}`;

        return queryClient.fetchQuery({
            queryKey: [requestType],
            queryFn: () => getFieldsOptions(fields),
            cacheTime: 0,
            retry: 2,
        });
    };

    return {
        getRegionsAndTimelineOptions,
    };
};
